var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('toggle-panel', {
    attrs: {
      "title": "YooMoney",
      "disabled": _vm.isDisabledPaymentOption
    },
    on: {
      "click": _vm.handleClickOnPanel
    },
    model: {
      value: _vm.isActivatedPaymentOption,
      callback: function callback($$v) {
        _vm.isActivatedPaymentOption = $$v;
      },
      expression: "isActivatedPaymentOption"
    }
  }, [_c('yoo-money-icon', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  })], 1), _c('cs-dialog', {
    on: {
      "close": _vm.handleCloseSettings
    },
    model: {
      value: _vm.isShownSettings,
      callback: function callback($$v) {
        _vm.isShownSettings = $$v;
      },
      expression: "isShownSettings"
    }
  }, [_c('dialog-default-layout', [_c('div', {
    staticClass: "modal-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('yoomoney.setting')))]), _c('a', {
    staticClass: "modal-help-icon",
    attrs: {
      "href": "https://help.capusta.space/payment_page/yoomoney",
      "target": "_blank"
    }
  })]), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('capusta-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: '####################',
      expression: "'####################'"
    }],
    attrs: {
      "error": !_vm.isValidAccountNumber,
      "validation": _vm.validateAccountNumber,
      "label": _vm.$t('yoomoney.wallet.number'),
      "placeholder": _vm.$t('enter.number'),
      "data-private": ""
    },
    model: {
      value: _vm.accountNumber,
      callback: function callback($$v) {
        _vm.accountNumber = $$v;
      },
      expression: "accountNumber"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('capusta-input', {
    attrs: {
      "label": _vm.$t('secret.authentication'),
      "placeholder": _vm.$t('enter.code'),
      "data-private": ""
    },
    model: {
      value: _vm.secretToken,
      callback: function callback($$v) {
        _vm.secretToken = $$v;
      },
      expression: "secretToken"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('capusta-input', {
    attrs: {
      "label": _vm.$t('purpose.of.transfers'),
      "placeholder": _vm.$t('example.consultation'),
      "data-private": ""
    },
    model: {
      value: _vm.descriptionTransfers,
      callback: function callback($$v) {
        _vm.descriptionTransfers = $$v;
      },
      expression: "descriptionTransfers"
    }
  })], 1)]), _c('div', {
    staticClass: "buttons-container",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('cs-button', {
    attrs: {
      "width": _vm.buttonWidth,
      "disabled": !_vm.isValidForm
    },
    on: {
      "click": _vm.handleApplyOption
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.apply')) + " ")]), _c('cs-button', {
    attrs: {
      "width": _vm.buttonWidth,
      "type": "transparent"
    },
    on: {
      "click": _vm.handleCloseSettings
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }